import * as React from "react";
import { Form, Input } from "antd";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import * as Constants from "../../../common/Constants";

export interface State {}

export interface CreatePositionTypeFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
}

class CreatePositionTypeForm extends React.Component<
  CreatePositionTypeFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newData = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newData = values;
        }
      });
      return newData;
    });
  }

  render() {
    const { translate } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <Form>
        <Form.Item label={translate("position_type_form.name")}>
          {getFieldDecorator(Constants.PositionTypeInsertForm.Fields.NAME, {
            rules: [
              {
                required: true,
                message: translate("position_type_form.required_messages", {
                  field: translate("position_type_form.name")
                })
              }
            ]
          })(<Input />)}
        </Form.Item>
      </Form>
    );
  }
}

export default CreatePositionTypeForm;
